import useAPI from './useAPI'

export default function usePendingCancellations() {
  const { data, error, mutate } = useAPI('/admin/pending-cancellations', 'get')

  return {
    items: data?.Items,
    isLoading: !data && !error,
    error,
    mutate,
  }
}